import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from '../generic.service';
import { YouTubeResponse } from '../../models/youtube/youTubeResponse';
import { YoutubePlaylistResponse } from '../../models/youtube/youtubePlaylistResponse';
import { YoutubePlaylistItemsResponse } from '../../models/youtube/youtubePlaylistItemsResponse';
import { YoutubeVideoResponse } from '../../models/youtube/youtubeVideoResponse';

@Injectable({
  providedIn: 'root'
})
export class YoutubeService {

  constructor(private genericService: GenericService) { }

  getPlaylists(nextPageToken?: string): Observable<YouTubeResponse<YoutubePlaylistResponse[]>>{
    const params: any = {};
    if (nextPageToken) {
      params.pageToken = nextPageToken;
    }
    return this.genericService.get('user/youtube/playlists', {
      params: params
    });
  }

  getPlaylistVideos(playlistId: string, nextPageToken?: string): Observable<YouTubeResponse<YoutubePlaylistItemsResponse[]>>{
    const params: any = {};
    if (nextPageToken) {
      params.pageToken = nextPageToken;
    }
    return this.genericService.get(`user/youtube/playlists/${playlistId}/videos`, {
      params: params
    });
  }
  
  getVideos(nextPageToken?: string): Observable<YouTubeResponse<YoutubePlaylistItemsResponse[]>>{
    const params: any = {};
    if (nextPageToken) {
      params.pageToken = nextPageToken;
    }
    return this.genericService.get(`user/youtube/videos`, {
      params: params
    });
  }
}
